<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="bussinessItems"
            type="none"
            itemText="codeName"
            itemValue="code"
            name="business"
            label="게시판 구분"
            v-model="searchParam.business"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            name="keyword"
            label="제목 키워드"
            v-model="searchParam.keyword">
          </c-text>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="한국산업안전공단 국내재해사례 게시판"
      :columns="grid.columns"
      :gridHeight="grid.height"
      :data="grid.data"
      :columnSetting="false"
      :expandAll="true"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <!--검색-->
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name ==='keyword'">
          <span class="text-blue text-weight-bold">
            {{props.row[col.name]}}
            <q-tooltip 
              self="top left"
              :offset="[0, 15]"
              content-style="font-size: 13px !important; padding: 15px !important;">
              {{ props.row.contents }}
            </q-tooltip>
          </span>
        </template>
        <template v-if="col.name ==='custom'">
          <q-icon name="launch" color="blue" size="xs" class="cursor-pointer" @click="linkClick(props)" />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
// import selectConfig from '@/js/selectConfig';
export default {
  name: 'saf-hea-manage-policy',
  data() {
    return {
      popupOptions: {
        isFull: false,
        target: null,
        title: '',
        width: '60%',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      dshow: false,
      bussinessItems: [
        {
          code: '제조업',
          codeName: '제조업',
        },
        {
          code: '직업병',
          codeName: '직업병',
        },
        {
          code: '중대산업사고',
          codeName: '중대산업사고',
        },
        {
          code: '중대사고 이슈리포트',
          codeName: '중대사고 이슈리포트',
        },
      ],
      grid: {
        columns: [
          {
            name: 'business',
            field: 'business',
            label: '구분',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'keyword',
            field: 'keyword',
            label: '제목',
            align: 'left',
            type: 'custom',
            sortable: true,
          },
          {
            name: 'custom',
            field: 'custom',
            label: 'KOSHA 링크',
            align: 'center',
            sortable: false,
            style: 'width:100px',
            type: 'custom'
          },
        ],
        data: [],
      },
      searchParam: {
        business: '제조업',
        keyword: '',
        numRows: '1000000',
        pageNo: '1',
      },
      period: [],
      editable: true,
      listUrl: '',
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'SHM_POLICY',
        taskKey: '',
      },
      selectedRow: {},
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = '/api/openapi/accident/kosha';
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data.body.items.item;
        console.log(_result.data.body.items.item)
      },);
    },
    linkClick(_props) {
      const width = 1500;
      const height = 900;

      // 현재 화면 크기 가져오기
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;

      // 중앙 정렬을 위한 좌표 계산
      const left = (screenWidth - width) / 2;
      const top = (screenHeight - height) / 2;

      window.open(
        'https://www.kosha.or.kr/kosha/data/machine.do?mode=view&articleNo=' + _props.row.boardno + '&article.offset=1340&articleLimit=10', 
        '한국산업안전공단 원본링크', 
        `width=${width}, height=${height}, left=${left}, top=${top}, scrollbars=yes, resizable=yes`)
    },
  }
};
</script>
<style lang="scss">
.accboradlink {
  margin-bottom: 10px;
}
.fixheaderCard {
  position: fixed !important;
  right: 10px;
  bottom: 20px;
}
</style>
